
import ModalPopup from './ModalPopup';
import TiwiMixin from '../mixins/TiwiMixin'

export default {
  mixins: [TiwiMixin],
  components: {
    ModalPopup
  },
  props: {
    
    modalId: {
      required: false,
    },

    videoUrl: {
      required: true
    },

    buttonLabel: {
      type: String,
      default: '<i class="ci ci-play"></i>',
    },
    buttonClass: {
      type: String,
      default: 'btn btn-round-lg btn-black',
    },
    modalTitle: {
      type: String,
    },

  },
  mounted: function () {
    this.show_modal = false;
  },
  data() {
    return {
      show_modal: false,
    }
  },
  methods: {
    onClose: function () {
      this.showModal(false);
    },
    showModal: function (status) {
      this.show_modal = status;
    }
  },
  computed: {
    currentVideoUrl: function () {
      return this.show_modal ? this.videoUrl : '';
    },
    getModalId: function(){
      return this.modalId ? this.modalId : 'video_modal_' + this._uid;
    }
  }
}
